// Layout.js
import React, { useState, useEffect } from "react";
import InfluencerHeader from "../InfluencerHeader";
import InfluencerFooter from "../InfluencerFooter";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("All Campaigns");
  const [influencer, setInfluencer] = useState(() => {
    const storedInfluencer = localStorage.getItem("influencer");
    try {
      return (
        location.state?.influencer ||
        (storedInfluencer ? JSON.parse(storedInfluencer) : "")
      );
    } catch (e) {
      console.error("Failed to parse influencer from localStorage", e);
      return "";
    }
  });

  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   params.set(
  //     "view",
  //     activeTab === "My Dashboard" ? "my-dashboard" : "all-campaigns"
  //   );

  //   // only All Campaigns needs pagination/filter
  //   // if (activeTab === "All Campaigns") {
  //   //   params.set("page", currentPage);
  //   //   params.set("filter", filter);
  //   // }

  //   setSearchParams(params);
  // }, [activeTab, setSearchParams]);

  return (
    // <div className="min-h-screen flex flex-col">
    //   <InfluencerHeader />
    //   <main className="flex-grow flex items-center justify-center">
    //     <div className="w-full max-w-[1440px] flex flex-col items-center justify-center px-6">
    //       <div className="w-full flex justify-center my-[50px]">{children}</div>
    //     </div>
    //   </main>
    //   <InfluencerFooter />
    // </div>
    <div className="min-h-screen flex flex-col">
      <InfluencerHeader
      // influencer={influencer}
      // activeTab={activeTab}
      // setActiveTab={setActiveTab}
      />
      <main className="flex-1 flex min-h-0">
        <div className="flex-1 flex items-center justify-center py-4 px-[10px] lg:px-[90px]">
          {children}
        </div>
      </main>
      <InfluencerFooter />
    </div>
  );
};

export default Layout;
